import { render, staticRenderFns } from "./SpinnerArea.vue?vue&type=template&id=29f423ce&scoped=true&"
import script from "./SpinnerArea.vue?vue&type=script&lang=ts&"
export * from "./SpinnerArea.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerArea.vue?vue&type=style&index=0&id=29f423ce&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f423ce",
  null
  
)

export default component.exports